import { POST } from "@/utils/axios";

export function createOrder(data){
    return POST('/order/createOrder', data);
}

export function checkOrderStatus(data){
    return POST('/order', data);
}

export function getPricePackageList(){
    return POST('/pricePackage/list',{});
}